import React from 'react'
import {usePage} from "@inertiajs/inertia-react";
import {PLANS} from "@/Enums/plans";

export function PlanPermissionContainer({
  plan = PLANS.LIGHT,
  children
}) {

  const organization = usePage().props?.organization?.data || {}
  const isLightPlan = organization?.plan === plan;

  return (
    <>
      {isLightPlan ? children : null}
    </>
  )
}
